/* =====================================================================
 * Map Controls
 * =====================================================================
 * 1. Helpers
 * ===================================================================*/

import regioes from '../../../data/regioes.json';
import vendedores from '../../../data/vendedores.json';

(function (doc) {

  const stateSelect = doc.getElementById('stateSelect');
  const citySelect = doc.getElementById('citySelect');
  const mapWrapper = doc.querySelector('.mapWrapper');
  const contactWrapper = doc.querySelector('.contactWrapper');

  const states = {
    'AC' : 'Acre',
    'AL' : 'Alagoas',
    'AP' : 'Amapá',
    'AM' : 'Amazonas',
    'BA' : 'Bahia',
    'CE' : 'Ceará',
    'DF' : 'Distrito Federal',
    'ES' : 'Espírito Santo',
    'GO' : 'Goiás',
    'MA' : 'Maranhão',
    'MT' : 'Mato Grosso',
    'MS' : 'Mato Grosso do Sul',
    'MG' : 'Minas Gerais',
    'PA' : 'Pará',
    'PB' : 'Paraíba',
    'PR' : 'Paraná',
    'PE' : 'Pernambuco',
    'PI' : 'Piauí',
    'RJ' : 'Rio de Janeiro',
    'RN' : 'Rio Grande do Norte',
    'RS' : 'Rio Grande do Sul',
    'RO' : 'Rondônia',
    'RR' : 'Roraima',
    'SC' : 'Santa Catarina',
    'SP' : 'São Paulo',
    'SE' : 'Sergipe',
    'TO' : 'Tocantins'
  };

  if (!stateSelect || !citySelect) return;

  Object.keys(regioes).forEach((key) => {
    const option = doc.createElement('option');
    option.value = key;
    option.text = states[key];
    stateSelect.add(option);
  });

  stateSelect.disabled = false;

  stateSelect.addEventListener('change', () => {
    const firstOption = citySelect.options[0];
    citySelect.innerHTML = '';
    citySelect.add(firstOption);
    citySelect.disabled = true;
    citySelect.selectedIndex = 0;

    regioes[stateSelect.value].forEach((city) => {
      const option = doc.createElement('option');
      option.text = city.cidade;
      option.value = city.vendedorId;
      citySelect.add(option);
    });

    citySelect.disabled = false;
  });

  citySelect.addEventListener('change', () => {
    const vendedorId = citySelect.value;
    const vendedor = vendedores.find(vendedor => vendedor.id == vendedorId);

    mapWrapper.classList.add('u-hide');
    contactWrapper.classList.remove('u-hide');

    const estate = doc.querySelector('.contactEstate');
    estate.innerHTML = stateSelect.options[stateSelect.selectedIndex].text;

    const city = doc.querySelector('.contactCity');
    city.innerHTML = citySelect.options[citySelect.selectedIndex].text;

    const name = doc.querySelector('.contactName');
    name.innerHTML = vendedor.nome;

    const email = doc.querySelector('.contactEmail');
    email.href = 'mailto:' + vendedor.email;
    email.innerHTML = vendedor.email;

    const phone = doc.querySelector('.contactPhone');
    phone.href = 'tel:055' + vendedor.telefone.replace(/\D/g, '');
    phone.innerHTML = 'Ligue agora ' + vendedor.telefone;
  });

  const showMap = doc.querySelector('.js-showMap');
  if (!showMap) return;

  showMap.addEventListener('click', () => {
    mapWrapper.classList.remove('u-hide');
    contactWrapper.classList.add('u-hide');
  });

}(document));
